import { RecordVoiceOver, VoiceOverOff } from "@mui/icons-material";
import { CircularProgress, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import Character from "../models/character";

interface VoiceSampleProps {
  character: Character;
}

let voiceSampleAudio: HTMLAudioElement | null = null;

const VoiceSampleButton: React.FC<VoiceSampleProps> = (props) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [playheadPosition, setPlayheadPosition] = useState<number>(0);

  useEffect(() => {
    // Set playhead to 0 for every new character:
    setPlayheadPosition(0);
    return function cleanup() {
      // Pause and remove audio when switching characters
      voiceSampleAudio?.pause();
      voiceSampleAudio = null;
    };
  }, [props.character]);

  return (
    <>
      <Box position="relative" display="inline-flex" zIndex={0}>
        <CircularProgress variant="determinate" value={playheadPosition} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          alignItems="center"
          justifyContent="center"
        >
          {props.character.voiceSampleFile ? (
            <IconButton
              color={isPlaying ? "success" : "warning"}
              onClick={handleVoiceSampleClick}
            >
              <RecordVoiceOver />
            </IconButton>
          ) : (
            <IconButton>
              <VoiceOverOff color="error" />
            </IconButton>
          )}
        </Box>
      </Box>
    </>
  );

  function handleVoiceSampleClick() {
    const voiceSampleFile = props.character.voiceSampleFile;
    if (voiceSampleFile) {
      const currentCharacterVoiceSampleAudio = new Audio(
        "assets/voice/" + voiceSampleFile,
      );

      if (voiceSampleAudio === null || voiceSampleAudio.paused === true) {
        // No voice sample has been played yet OR currently no voice sample is playing.
        // Assign and play current character's voice sample:

        voiceSampleAudio = currentCharacterVoiceSampleAudio;
      }

      // Voice sample audio is currently playing.
      else {
        // Pause whichever voice sample is playing
        voiceSampleAudio.pause();

        if (voiceSampleAudio.src === currentCharacterVoiceSampleAudio.src) {
          // Same character's voice sample is playing.
          // Return to avoid playing the voice sample again:
          return;
        } else {
          // Some other character's voice sample is playing.
          // Play new character:
          voiceSampleAudio = currentCharacterVoiceSampleAudio;
        }
      }

      voiceSampleAudio.play();
      setIsPlaying(true);
      const intervalToUpdatePlayhead = setInterval(() => {
        updateAudioPlayhead();
      }, 100);
      voiceSampleAudio.onpause = () => {
        updateAudioPlayhead();
        clearInterval(intervalToUpdatePlayhead);
        setIsPlaying(false);
      };
    }

    function updateAudioPlayhead() {
      if (voiceSampleAudio) {
        const newPlayheadPosition =
          (voiceSampleAudio.currentTime / voiceSampleAudio.duration) * 100;
        setPlayheadPosition(newPlayheadPosition);
      }
    }
  }
};

export default VoiceSampleButton;
